function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 *  Register actions for a entity in redux state, which are then connected to components using
 *  `entityComposition`.
 *
 *  Without registration, requests will fall through to the default "lookup/<table>" actions.
 */
import customLookupMap from './customLookupMap';
import documentActionFactory from './factories/documentActionFactory';
import entityActionFactory from './factories/entityActionFactory';
import annotationActionCreators from './annotationActionCreators';
import annotationSelectionActionCreators from './annotationSelectionActionCreators';
import assetActionCreators from './assetActionCreators';
import cabinetActionCreators from './cabinetActionCreators';
import cabinetFilterOptionsActionCreators from './cabinetFilterOptionsActionCreators';
import contractSpecActionCreators from './contractSpecActionCreators';
import documentTagSelectDocumentActionCreators from './documentTagSelectDocumentActionCreators';
import employeeActionCreators from './employeeActionCreators';
import deferredActionCreators from './deferredActionCreators';
import fillReportSelectEditorActionCreators from './fillReportSelectEditorActionCreators';
import fillReportSelectJobActionCreators from './fillReportSelectJobActionCreators';
import formActionCreators from './formActionCreators';
import formModalActionCreators from './formModalActionCreators';
import infoActionCreators from './infoActionCreators';
import issueActionCreators from './issueActionCreators';
import jobActionCreators from './jobActionCreators';
import loginActionCreators from './loginActionCreators';
import mapActionCreators from './mapActionCreators';
import mfaActionCreators from './mfaActionCreators';
import organizationActionCreators from './organizationActionCreators';
import passwordActionCreators from './passwordActionCreators';
import reportActionCreators from './reportActionCreators';
import reportAnnotationActionCreators from './reportAnnotationActionCreators';
import reportDocumentActionCreators from './reportDocumentActionCreators';
import reportFilterActionCreators from './reportFilterActionCreators';
import reportReferenceActionCreators from './reportReferenceActionCreators';
import reportIssueBulkExportActionCreators from './reportIssueBulkExportActionCreators';
import reportTagActionCreators from './reportTagActionCreators';
import schemaActionCreators from './schemaActionCreators';
import tokenErrorActionCreators from './tokenErrorActionCreators';
import userActionCreators from './userActionCreators';
import notificationActionCreators from './notificationActionCreators';
import pickerActionCreators from './pickerActionCreators';
import settingsActionCreators from './settingsActionCreators';
import summaryFilterOptionsActionCreators from './summaryFilterOptionsActionCreators';

// document actions. Note usage of a factory, which is necessary to pick up custom actions and have
// them properly associated with the entity name
const documentActionCreators = documentActionFactory('document');
const documentSelectJobActionCreators = documentActionFactory('documentSelectJob');
const documentModalJobActionCreators = documentActionFactory('documentModalJob');
const actionRegistry = {};
const addToRegistry = (entity, actions) => {
  if (!actionRegistry[entity]) {
    actionRegistry[entity] = actions;
  }
};
export const registerActions = () => {
  addToRegistry('annotation', annotationActionCreators);
  addToRegistry('annotationSelection', annotationSelectionActionCreators);
  addToRegistry('asset', assetActionCreators);
  addToRegistry('cabinet', cabinetActionCreators);
  addToRegistry('cabinetFilterOptions', cabinetFilterOptionsActionCreators);
  addToRegistry('contractSpec', contractSpecActionCreators);
  addToRegistry('deferred', deferredActionCreators);
  addToRegistry('document', documentActionCreators);
  addToRegistry('documentTagSelectDocument', documentTagSelectDocumentActionCreators);
  addToRegistry('documentSelectJob', documentSelectJobActionCreators);
  addToRegistry('documentModalJob', documentModalJobActionCreators);
  addToRegistry('employee', employeeActionCreators);
  addToRegistry('fillReportSelectEditor', fillReportSelectEditorActionCreators);
  addToRegistry('fillReportSelectJob', fillReportSelectJobActionCreators);
  addToRegistry('form', formActionCreators);
  addToRegistry('formModal', formModalActionCreators);
  addToRegistry('info', infoActionCreators);
  addToRegistry('issue', issueActionCreators);
  addToRegistry('job', jobActionCreators);
  addToRegistry('login', loginActionCreators);
  addToRegistry('map', mapActionCreators);
  addToRegistry('mfa', mfaActionCreators);
  addToRegistry('organization', organizationActionCreators);
  addToRegistry('password', passwordActionCreators);
  addToRegistry('report', reportActionCreators);
  addToRegistry('reportDocument', reportDocumentActionCreators);
  addToRegistry('reportAnnotation', reportAnnotationActionCreators);
  addToRegistry('reportFilter', reportFilterActionCreators);
  addToRegistry('reportReference', reportReferenceActionCreators);
  addToRegistry('reportIssueBulkExport', reportIssueBulkExportActionCreators);
  addToRegistry('reportTag', reportTagActionCreators);
  addToRegistry('schema', schemaActionCreators);
  addToRegistry('summaryFilterOptions', summaryFilterOptionsActionCreators);
  addToRegistry('tokenError', tokenErrorActionCreators);
  addToRegistry('user', userActionCreators);
  addToRegistry('notification', notificationActionCreators);
  addToRegistry('picker', pickerActionCreators);
  addToRegistry('settings', settingsActionCreators);
};

/**
 *  Register actions for lookup in component code. Specific action creators are
 *  included in appActions, which will call this method. If a request is made
 *  for an entity not yet registered, attempt to retrieve it though the
 *  "lookup/<table>" route
 */
export const actionRegistrar = entity => {
  // return existing action registrations
  let result = actionRegistry[entity];
  if (result) {
    return result;
  }

  // default action registration
  const tableName = entity.charAt(0).toUpperCase() + entity.slice(1);
  // lookup routes can be overridden, otherwise the default "lookup/Table" is used
  const lookupRoute = customLookupMap[entity] ? customLookupMap[entity] : `lookup/${tableName}`;
  const entityActions = entityActionFactory(entity, lookupRoute);
  result = _objectSpread({}, entityActions);
  addToRegistry(entity, result);
  return result;
};